import { create } from 'zustand';
import {
  MasterObjectType,
  MasterPayoutObjectType,
} from 'pages/master/schedule/types';

const daysCount = 14;

type ListState = {
  isLoaded: boolean;
  data: MasterObjectType[];
};

type PayoutListState = {
  isLoaded: boolean;
  data: MasterPayoutObjectType[];
};

export type ScheduleStoreState = {
  daysCount: number;
  list: ListState;
  setList: (updater: ListState | ((prevList: ListState) => ListState)) => void;
  payoutList: PayoutListState;
  setPayoutList: (
    updater: PayoutListState | ((prevList: PayoutListState) => PayoutListState)
  ) => void;
  isError: boolean;
  setIsError: (isError: boolean) => void;
  isPostInProcess: boolean;
  setIsPostInProcess: (isPostInProcess: boolean) => void;
  fromDate: string;
  setFromDate: (updater: string | ((prevDate: string) => string)) => void;
};

const useScheduleStore = create<ScheduleStoreState>((set, get) => ({
  daysCount: daysCount,
  list: {
    isLoaded: false,
    data: [],
  },
  setList: (updater) => {
    if (typeof updater === 'function') {
      set((state) => ({
        list: updater(state.list),
      }));
    } else {
      set({ list: updater });
    }
  },
  payoutList: {
    isLoaded: false,
    data: [],
  },
  setPayoutList: (updater) => {
    if (typeof updater === 'function') {
      set((state) => ({
        payoutList: updater(state.payoutList),
      }));
    } else {
      set({ payoutList: updater });
    }
  },
  isError: false,
  setIsError: (isError) => set({ isError }),
  isPostInProcess: false,
  setIsPostInProcess: (isPostInProcess) => set({ isPostInProcess }),
  fromDate: new Date().toISOString().split('T')[0],
  setFromDate: (updater) => {
    if (typeof updater === 'function') {
      set((state) => ({
        fromDate: updater(state.fromDate),
      }));
    } else {
      set({ fromDate: updater });
    }
  },
}));

export default useScheduleStore;
